<template>
  <figure class="c-carousel">
    <vue-glide
      :bullet="false"
      :perView="1"
      :bound="true"
      v-model="active"
    >
      <vue-glide-slide
        v-for="image in imageable"
        :key="image.image_id"
      >
        <div @click="openModal()">
          <ResponsiveImage
            v-if="image.image_id"
            :id="image.image_id"
            :css="'c-carousel__image'"
          />
          <ImageCaption
            v-if="image.image_id"
            :id="image.image_id"
            :css="'c-carousel__caption'"
          />
        </div>
      </vue-glide-slide>
      <template
        slot="control"
        class="glide__nav"
      >
        <button
          data-glide-dir="<"
          class="c-carousel__nav c-carousel__nav--prev"
          aria-label="Forrige bilde"
        >
          <icon-left class="c-carousel__icon" />
        </button>
        <button
          data-glide-dir=">"
          class="c-carousel__nav c-carousel__nav--next"
          aria-label="Neste bilde"
        >
          <icon-right class="c-carousel__icon" />
        </button>
      </template>
    </vue-glide>
    <nav class="c-carousel__thumbnails">
      <button
        v-for="(image, index) in imageable"
        :key="image.image_id"
        :class="{ 'is-active': index === active }"
        @click="active = index"
        class="c-carousel__indicator"
      >
        <ResponsiveImage
          v-if="image.image_id"
          :id="image.image_id"
          :class="'c-carousel__thumbnail'"
        />
      </button>
    </nav>
  </figure>
</template>

<script>
import { EventBus } from '@/event-bus.js';

// Data models
import Imageable from '@/models/Imageable';

import { Glide, GlideSlide } from 'vue-glide-js';
import ResponsiveImage from '@/components/ResponsiveImage.vue';
import ImageCaption from '@/components/ImageCaption.vue';
import IconLeft from '@/components/icons/IconLeft.vue';
import IconRight from '@/components/icons/IconRight.vue';

export default {
  name: 'Carousel',
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
    ResponsiveImage,
    ImageCaption,
    IconLeft,
    IconRight,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    residence_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      active: 0,
    };
  },
  computed: {
    imageable() {
      return Imageable.query().where('imageable_id', this.residence_id).get();
    },
  },
  methods: {
    openModal() {
      EventBus.$emit('open-modal-illustration', true);
    },
  },
};
</script>
